import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiGrid, FiClock, FiUsers, FiBriefcase, FiPieChart, FiPlayCircle } from 'react-icons/fi';

const navItems = [
  { id: 'dashboard', icon: FiGrid },
  { id: 'demo', icon: FiPlayCircle },
  { id: 'timeline', icon: FiClock },
  { id: 'guests', icon: FiUsers },
  { id: 'vendors', icon: FiBriefcase },
  { id: 'budget', icon: FiPieChart },
];

export default function MobileNav({ activeTab, setActiveTab }) {
  return (
    <div className="sm:hidden fixed bottom-0 left-0 w-full glass-panel rounded-none border-b-0 border-x-0 z-50 pb-safe">
      <div className="flex justify-around items-center p-3">
        {navItems.map((item) => {
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`p-3 rounded-full transition-all ${
                isActive ? 'bg-[#9D4EDD]/20 text-[#E5C158]' : 'text-[#94A3B8]'
              }`}
            >
              <SafeIcon icon={item.icon} className="text-xl" />
            </button>
          );
        })}
      </div>
    </div>
  );
}